/**
 * HTTP Request Service
 * Modular request handler with focused responsibilities
 * More detailed api documentation: https://github.com/umijs/umi-request
 */
import { extend } from 'umi-request';
import { createErrorHandler } from './errorHandler';
import { createRequestInterceptor, createResponseInterceptor } from './requestConfig';

// Global abort controller for network error handling
const abortController = new AbortController();
const { signal } = abortController;

const request = extend({
  errorHandler: createErrorHandler(abortController),
  credentials: 'include',
  timeout: 120_000,
  signal,
});

request.interceptors.request.use(createRequestInterceptor(abortController));
request.interceptors.response.use(createResponseInterceptor(abortController), { global: false });

// Re-export token utilities for backward compatibility
export { getToken, isTokenExpired } from './tokenManager';
export default request;
